import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Container, Row, Button } from 'reactstrap';

import Spinners from './Spinners';
import ErrorPage from './ErrorPage';
import Header from './Header';
// import Footer from './Footer';
import './AuthenticationPage.css';

class ChangeOpponent extends React.Component {
  constructor() {
    super();
    this.state = {
      teamsToChange: [],
      isLoading: true,
      isError: false,
      error: {}
    };

    this.storeImageOpponent = this.storeImageOpponent.bind(this);
  }

  storeImageOpponent(event, logo) {
    localStorage.setItem('logoOpponent', logo);
    const choiceOpponent = event.target.id;
    const newTeamsOpponent = this.state.teamsToChange.map(el => {
      if (el.uuid === choiceOpponent) {
        return { ...el, isClicked: !el.isClicked };
      }
      return { ...el, isClicked: false };
    });
    this.setState({ teamsToChange: newTeamsOpponent });
  }

  componentDidMount() {
    axios
      .get('https://c-clicker-api.herokuapp.com/teams')
      .then(res => {
        const datas = res.data;
        this.setState({ teamsToChange: datas, isLoading: false });
      })
      .then(() => {
        const newTeams = this.state.teamsToChange.map(team => {
          return { ...team, isClicked: false };
        });
        this.setState({ teamsToChange: newTeams });
      })
      .catch(err => {
        console.log(err);
        this.setState({ isError: true, error: err });
      });
  }

  render() {
    const { isError, isLoading, teamsToChange, error } = this.state;

    if (isLoading) {
      return <Spinners />;
    } else if (isError) {
      return <ErrorPage error={error} />;
    } else {
      return (
        <Container fluid className="flex-column min-vh-100 vw-100 align-items-center">
          <Header />
          <Container className="flex-column justify-content-center m-perso w-container border border-white rounded">
            <Row className="mx-1 pb-5 pt-5">
              <h1>Choisir une autre team à boxer :</h1>
            </Row>
            <Row className="align-self-center d-flex justify-content-around flex-wrap mx-1 mb-5 p-light">
              {teamsToChange.map(team => {
                return (
                  <img
                    id={team.uuid}
                    key={team.uuid}
                    className={`logoTeam ${team.isClicked ? 'logoTeamColor' : 'logoTeamSepia'}`}
                    src={team.logo}
                    alt={team.name}
                    /*onClick={e => onClick(e, logo)*/
                    onClick={event => this.storeImageOpponent(event, team.logo)}
                  />
                );
              })}
            </Row>
            <Row className="justify-content-center mb-5">
              <Link to="/mainPagePlay">
                <Button color="warning">Retour au jeu !!!</Button>
              </Link>
            </Row>
          </Container>
          {/* <Row className="row-footer vw-100 justify-content-center align-items-center mt-5">
            <Footer />
          </Row> */}
        </Container>
      );
    }
  }
}

export default ChangeOpponent;
